import React, { useState } from 'react'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import Tabs from '../../../components/general/general-component/tabs/Tabs'
import FilterReport from './FilterReport'
import styles from './report.module.css'
import StatisticsSection from './StatisticsSection'
import LastMoves from './LastMoves'

export default function ReportAccounting() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const [activeTap, setActiveTap] = useState('account')
    const handleSectionClick = (sectionId) => {
        setActiveTap(sectionId);
    };
    const tabs = [
        {
            name: translate('accounts'),
            type: 'account',
            icon: 'fa fa-users'
        },
        {
            name: translate('statements'),
            type: 'statements',
            icon: 'fa fa-tasks'
        },
        {
            name: translate('expenses'),
            type: 'expenses',
            icon: 'fas fa-chart-pie'
        }
    ]
    return (
        <CheckLazyLoader>
            <main>
                <div className="margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative", backgroundColor: "white" }} >
                    <Tabs langLocal={langLocal} tabs={tabs} activeSection={activeTap} handleSectionClick={handleSectionClick} />
                    {
                        activeTap === 'account' &&
                        <>
                            <FilterReport translate={translate} bigTitle />
                            <div className={styles.both} >
                                <StatisticsSection translate={translate} />
                                <LastMoves translate={translate} />
                            </div>
                        </>
                    }
                    {
                        activeTap === 'statements' &&
                        <div style={{ height: "400px", display: "flex", alignItems: "center", justifyContent: "center" }} >
                            Currently unavailable
                        </div>
                    }
                    {
                        activeTap === 'expenses' &&
                        <div style={{ height: "400px", display: "flex", alignItems: "center", justifyContent: "center" }} >
                            Currently unavailable
                        </div>
                    }
                </div>
            </main>
        </CheckLazyLoader>
    )
}
